export const whoami = {
    name: "whoami",
    description: "Displays user info",
    run: () => `
Nickname: Cezary924
Name: Cezary Zięba
Role: Full-Stack Junior Developer
Location: Cracow, Poland
GitHub: https://github.com/cezary924
LinkedIn: https://www.linkedin.com/in/cezary-zieba
`.trim()
};